import React, { Component } from "react";
import Hero from "../commons/Hero";
import Navbar from "../commons/Navbar";


export class About extends Component {

  render() {
    return (
      <div className="about">
        <Navbar />

        <Hero 
          heading={["Hi, I'm Marcus Mckinstry", <br />, "Nice To Meet You"]}
          style={{
                backgroundColor: "rgb(37,64,90)",
                opacity: "0.35"
            }}
          image="assets/img/screenshots/lrg/7990.jpg"
        />

        <div className="container">
          <div className="content">
            <p>
              I'm a highly motivated, self-taught web developer seeking an entry
              level position in Web Design and Development, with an organization
              that I can grow with. My professional experience so far has
              consisted of static HTML/CSS websites, which been used by clients
              as introduction tools, and as a tool to expand their presence to a
              wider audience.
            </p>

            <p>
              My start in webdesign/development began with my church Mount
              Calvary Baptist Church. Mount Calvary, a church that has been a
              part of the community of Springfield, MA for nearly a century did
              not have a presence of any part of the web. My Pastor Dr. Mark E.
              Flowers felt it was time to extend its presence to the web, and
              try to broaden its outreach beyond its previous methods. Pastor
              Flowers had an abstract vision of how the site could look and be
              presented, but did not have any technical expertise of how to
              reach that goal.
            </p>

            <p>
              At that time from my college studies I had some, but not extensive
              experience when it comes to designing, coding, and implementing a
              website. Because I’ve been a member of the church for most of my
              life, and know its history, he asked would I be interested in
              designing the site. Since then the site continues to help the
              church spread its message, and reach wider audiences. I still
              continuously, update it with new and up to date information when
              necessary
            </p>

            <p>
              A friend from the church Arthur E. Cash, liked how the site turn
              out, and asked if I can design on for him. Arthur E. Cash is a
              Licensed Clinical Therapist who holds degrees and certifications
              in a variety of areas such as Social Work, Alcohol and Drugs,
              Domestic violence, Family Therapy / Couples Therapy and the
              treatment of issues relating to men. He has been a presence in the
              field of Mental Health for over 25 years, but did not have a
              presence on the internet, where his services can reach a bigger
              audience. Similar to Mount Calvary, his site continues as a tool
              help him reach a wider audience, and market his services.
            </p>

            <p>
              Since then my interest has grown beyond just statics HTML/CSS
              sites, and into more development with dynamics sites, using
              technologies, such as more advance JavaScript, PHP, JavaScript and
              PHP frameworks/libraries such as Laravel, React, CodeIgnighter,
              Express. In my spare time overtime, I used various resources such
              as Udemy.com courses, courses from Eduonix.com, as well as several
              small to medium size tutorials from YouTube, to help teach myself
              these technologies. Over time I have taken what I learned and
              built several projects mostly small, but a couple of medium sized
              one as well, where you can see on the projects page of this site.
              I have now moved to a point where I hope my growing interest can
              one day result in a fulltime career change into doing something I
              love.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
